module.exports = __webpack_public_path__ + "img/iconNo14.560cbe8a.png";